import { PageIntro } from "../components/site/PageIntro";
import { ImgReveal, FadeUp, DrawLine } from "../components/site/Reveal";
import { Btn } from "../components/site/Btn";
import { useSeo } from "../components/site/Seo";
import { useLang } from "../i18n/lang";
import { useSiteImages } from "../lib/siteImages";

const IMG_AFTER = { 0: ["process_1", "Natural stone slab"], 2: ["process_2", "Stone in the workshop"], 4: ["process_3", "Raw stone block"] };

export default function Process() {
  const { t, to } = useLang();
  const img = useSiteImages();
  useSeo(...t.seo.process);
  return (
    <main data-testid="process-page">
      <PageIntro n={0} label={t.process.label} title={t.process.title} text={t.process.intro} testid="process-intro" />
      <section className="px-6 sm:px-10 lg:px-14 pb-32">
        {t.process.phases.map(([title, text], i) => (
          <div key={title} data-testid={`process-phase-${i + 1}`}>
            <DrawLine />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 py-12 sm:py-16">
              <p className="lg:col-span-2 f-serif font-light text-7xl sm:text-8xl text-[#A3A3A3] leading-none">0{i + 1}</p>
              <h2 className="lg:col-span-4 f-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-[-0.015em] leading-[1.05]">{title}</h2>
              <FadeUp className="lg:col-span-5 lg:col-start-8"><p className="text-lg leading-[1.75] text-[#3A3A3A]">{text}</p></FadeUp>
            </div>
            {IMG_AFTER[i] && (
              <div className={`pb-16 grid grid-cols-1 lg:grid-cols-12`}>
                <ImgReveal src={img(IMG_AFTER[i][0])} alt={IMG_AFTER[i][1]}
                  className={`aspect-[16/10] ${i === 2 ? "lg:col-span-5 lg:col-start-3" : i === 4 ? "lg:col-span-8 lg:col-start-5" : "lg:col-span-6 lg:col-start-7"}`} />
              </div>
            )}
          </div>
        ))}
        <DrawLine />
        <p className="mt-6 text-xs text-[#555555]">{t.common.illustrative}</p>
        <div className="mt-16"><Btn to={to("/stones")} testid="process-start-cta">{t.process.cta}</Btn></div>
      </section>
    </main>
  );
}
